import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/analytics";
import "firebase/auth";
import * as firebaseui from "firebaseui";
import config from "../config/config";
import "firebase/performance";
import axios from "axios";

if (!firebase.apps.length) {
  firebase.initializeApp(config.firebaseConfig);
  if (config.environment === "production") firebase.analytics();
}
//firestore.enablePersistence({ synchronizeTabs: true });
export const firebaseUI = new firebaseui.auth.AuthUI(firebase.auth());

firebase.performance();

export const registerAuthCallback = (callback) => {
  firebase.auth().onAuthStateChanged(async function(user) {
    const appUser = user
      ? { id: user.uid, name: user.displayName, email: user.email }
      : null;
    await callback(appUser);
  });

  axios.interceptors.request.use(
    async (config) => {
      const user = firebase.auth().currentUser;
      if (user) {
        try {
          let token = await user.getIdToken();
          config.headers["Authorization"] = `Bearer ${token}`;
        } catch (error) {
          console.error(error);
        }
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
};

export default firebase;
